import { Component } from "@angular/core";
import {
    NavController,
    NavParams,
    ViewController,
    ToastController
} from "ionic-angular";

import { APIServiceProvider } from "../../common/services/api.service";
import { HelperServiceProvider } from "./../../common/services/helper.service";
import { NotifyService } from "../../services/notify.service";

@Component({
    selector: "modal-orderreceived",
    templateUrl: "./orderreceived.modal.html"
})
export class OrderreceivedModalPage {
    public order = {};
    public statusData = [{ id: 5, value: "Received" }];
    public orderData = {
        order_status: 5
    };

    public submitDisabled = false;

    constructor(
        public navCtrl: NavController,
        public viewCtrl: ViewController,
        public navParams: NavParams,
        private apiHelper: APIServiceProvider,
        public toastCtrl: ToastController,
        public helperService: HelperServiceProvider,
        public notifyService: NotifyService
    ) {
        this.order = this.navParams.get("order");
        // this.order["dispatched_date"] = moment(this.order["dispatched_date"])
        //     .format("DD-MMM-YYYY HH:mm:ss")
        //     .toString();
        this.orderData["order_id"] = this.order["order_id"];
    }

    dismiss() {
        this.viewCtrl.dismiss();
    }

    submitReceived() {
        this.submitDisabled = true;
        this.apiHelper
            .put("orders/update-order-status", this.orderData)
            .subscribe(
                result => {
                    this.notifyService.OrderModified(true);
                    this.submitDisabled = false;
                    this.helperService.presentToast("Success");
                    this.notifyService.OrderReceived(true);
                    this.viewCtrl.dismiss();
                },
                error => {
                    this.helperService.presentToast(
                        "Some error occurred, please refresh and try again"
                    );
                    this.submitDisabled = false;
                    this.viewCtrl.dismiss();
                }
            );
    }
}



// WEBPACK FOOTER //
// ./src/modals/orderreceived/orderreceived.modal.ts